import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "prevBtn", "nextBtn", "finishBtn", "indicator"]
  static values = { completeUrl: String }

  connect() {
    this.currentStep = 0
    this.totalSteps = this.stepTargets.length
    this.showStep(0)
  }

  next() {
    if (this.currentStep < this.totalSteps - 1) {
      this.showStep(this.currentStep + 1)
    }
  }

  prev() {
    if (this.currentStep > 0) {
      this.showStep(this.currentStep - 1)
    }
  }

  skip() {
    this.complete()
  }

  finish() {
    this.complete()
  }

  showStep(index) {
    this.currentStep = index

    this.stepTargets.forEach((step, i) => {
      step.classList.toggle("hidden", i !== index)
    })

    this.prevBtnTarget.classList.toggle("hidden", index === 0)
    this.nextBtnTarget.classList.toggle("hidden", index === this.totalSteps - 1)
    this.finishBtnTarget.classList.toggle("hidden", index !== this.totalSteps - 1)

    this.indicatorTargets.forEach((dot, i) => {
      if (i === index) {
        dot.classList.add("bg-amber-500")
        dot.classList.remove("bg-[#374151]")
      } else {
        dot.classList.remove("bg-amber-500")
        dot.classList.add("bg-[#374151]")
      }
    })
  }

  async complete() {
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      await fetch(this.completeUrlValue, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "application/json"
        }
      })
    } catch (_e) {
      // silently fail — tutorial will just show again next time
    }
    this.element.remove()
  }
}
